import Parse from "../parse";

/* =========================
   공통 Object 변환
========================= */
const toPlainObject = (obj) => {
  if (!obj) return null;

  return {
    _id: obj.id,
    objectId: obj.id,
    ...obj.toJSON(),
  };
};

/* =========================
   SELECT
========================= */
// select("tableName", {
//   where: { isCompleted: true },
//   order: { column: "elapsedTime", type: "asc" },
//   limit: 10,
//   columns: ["playerName"]
// })

export const select = async (tableName, options = {}) => {
  try {
    const { where, order, limit, columns } = options;

    const query = new Parse.Query(tableName);

    /* WHERE */
    if (where) {
      Object.entries(where).forEach(([key, value]) => {
        query.equalTo(key, value);
      });
    }

    /* ORDER */
    if (order?.column) {
      if (order.type === "desc") {
        query.descending(order.column);
      } else {
        query.ascending(order.column);
      }
    }

    /* LIMIT */
    if (limit) {
      query.limit(limit);
    }

    /* COLUMNS */
    if (columns?.length) {
      query.select(columns);
    }

    const results = await query.find();

    return results.map(toPlainObject);
  } catch (error) {
    console.error(`[SELECT] ${tableName} 실패`, error);
    return [];
  }
};

/* =========================
   INSERT
========================= */
export const insert = async (tableName, data = {}) => {
  try {
    const Table = Parse.Object.extend(tableName);
    const row = new Table();

    Object.entries(data).forEach(([key, value]) => {
      row.set(key, value);
    });

    const result = await row.save();

    return {
      _id: result.id,
      objectId: result.id,
    };
  } catch (error) {
    console.error(`[INSERT] ${tableName} 실패`, error);

    if (error.code === 137 || error.message?.includes("duplicate")) {
      throw new Error("DUPLICATE_NICKNAME");
    }

    throw error;
  }
};

/* =========================
   UPDATE
========================= */
export const update = async (tableName, id, data = {}) => {
  try {
    const Table = Parse.Object.extend(tableName);

    const row = new Table();
    row.id = id;

    Object.entries(data).forEach(([key, value]) => {
      // 배열 그대로 저장
      if (Array.isArray(value)) {
        row.set(key, value);
        return;
      }

      // __op 처리
      if (value && typeof value === "object" && value.__op) {
        switch (value.__op) {
          case "add":
            row.add(key, value.value);
            break;

          case "addUnique":
            row.addUnique(key, value.value);
            break;

          case "increment":
            row.increment(key, value.amount ?? 1);
            break;

          default:
            break;
        }

        return;
      }

      row.set(key, value);
    });

    await row.save();

    return true;
  } catch (error) {
    console.error(`[UPDATE] ${tableName} 실패`, error);
    return false;
  }
};

/* =========================
   DELETE
========================= */
export const deleteRow = async (tableName, id) => {
  try {
    const Table = Parse.Object.extend(tableName);

    const row = new Table();
    row.id = id;

    await row.destroy();

    return true;
  } catch (error) {
    console.error(`[DELETE] ${tableName} 실패`, error);
    return false;
  }
};
